import { useMutation } from '@tanstack/react-query';
import { generateMagicLink, generateResetLink } from 'apis/auth';
import { AxiosError } from 'axios';

const createLink = ({
  type,
  email,
}: {
  type: string;
  email?: string;
}): Promise<void> =>
  type === 'magic'
    ? generateMagicLink({ email })
    : generateResetLink({ email });

const useMutationCreateLink = ({
  onSuccess,
  onError,
}: {
  onSuccess: (
    data: unknown,
    variables: { email?: string; type: string }
  ) => void;
  onError: (e: AxiosError) => void;
}) => {
  const { mutate, data, isSuccess, isError } = useMutation(createLink, {
    onSuccess,
    onError,
  });

  return {
    data,
    mutate,
    isSuccess,
    isError,
  };
};

export default useMutationCreateLink;
